/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


if ($(window).width() <= 740) {
    $('body').on('click', '.footer__item-m--collapsible_toggle', function(){
        // only run on mobile
        $(this).toggleClass('active');
        $(this).next('.footer__item-content').slideToggle();
    });
}
(function ($) {
  'use strict';

  var SELECTOR = '[data-featured-marquee]';
  var NS = '.featuredMarquee';

  function build($marquee) {
    var marquee = $marquee[0];
    var $viewport = $marquee.find('[data-fm-viewport]');
    var $track = $marquee.find('[data-fm-track]');
    var $group = $marquee.find('[data-fm-group]').not('[data-fm-clone]').first();
    if (!$viewport.length || !$track.length || !$group.length) return;

    // Reduced motion: leave the static centered row the CSS already shows.
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    // Remove clones from any previous build so measurement uses one clean set.
    $track.find('[data-fm-clone]').remove();
    $marquee.removeAttr('data-fm-ready');

    var styles = window.getComputedStyle($track[0]);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    var groupWidth = $group[0].getBoundingClientRect().width;

    // Row not laid out yet (images still decoding) — waitForImages will retry.
    if (groupWidth <= 0) return;

    // Distance travelled before the strip visually repeats: one set + one gap.
    var shift = groupWidth + gap;
    var containerWidth = $viewport[0].getBoundingClientRect().width;

    // Enough copies to keep the viewport full through the whole cycle.
    var totalGroups = Math.ceil(containerWidth / shift) + 2;
    var clonesNeeded = Math.max(1, totalGroups - 1);

    var frag = document.createDocumentFragment();
    for (var c = 0; c < clonesNeeded; c++) {
      var clone = $group[0].cloneNode(true);
      clone.setAttribute('data-fm-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      $(clone).find('a').attr('tabindex', '-1');
      frag.appendChild(clone);
    }
    $track[0].appendChild(frag);

    var speed = parseFloat(marquee.dataset.speed) || 60; // px per second
    var duration = shift / speed; // constant visual speed regardless of logo count

    // Restart cleanly so a resize/rebuild never jumps mid-loop.
    $track.css('animation', 'none');
    $track[0].style.setProperty('--fm-shift', shift + 'px');
    $track[0].style.setProperty('--fm-duration', duration + 's');
    void $track[0].offsetWidth; // force reflow
    $track.css('animation', '');

    $marquee.attr('data-fm-ready', '');
  }

  function waitForImages($marquee) {
    var imgs = $marquee.find('[data-fm-group]').not('[data-fm-clone]').find('img').toArray();
    var pending = imgs.filter(function (img) {
      return !img.complete || img.naturalWidth === 0;
    });
    if (!pending.length) return Promise.resolve();

    return Promise.all(
      pending.map(function (img) {
        return new Promise(function (resolve) {
          img.addEventListener('load', resolve, { once: true });
          img.addEventListener('error', resolve, { once: true });
        });
      })
    );
  }

  function init(marquee) {
    var $marquee = $(marquee);
    if ($marquee.data('fmInit')) destroy(marquee); // destroy-before-reinit guard
    $marquee.data('fmInit', true);

    var rebuild = debounce(function () {
      build($marquee);
    }, 150);

    waitForImages($marquee).then(function () {
      build($marquee);
    });

    var viewport = $marquee.find('[data-fm-viewport]')[0];
    if ('ResizeObserver' in window && viewport) {
      var ro = new ResizeObserver(rebuild);
      ro.observe(viewport);
      $marquee.data('fmObserver', ro);
    } else {
      $(window).on('resize' + NS + '-' + marquee.id, rebuild);
    }
  }

  function destroy(marquee) {
    var $marquee = $(marquee);
    var ro = $marquee.data('fmObserver');
    if (ro) ro.disconnect();
    $(window).off('resize' + NS + '-' + marquee.id);
    $marquee.find('[data-fm-clone]').remove();
    $marquee.removeAttr('data-fm-ready').removeData('fmInit').removeData('fmObserver');
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function initAll(root) {
    $(root || document).find(SELECTOR).addBack(SELECTOR).each(function () {
      init(this);
    });
  }

  $(function () {
    initAll();
  });

  // Theme editor lifecycle.
  $(document).on('shopify:section:load', function (e) {
    initAll(e.target);
  });
  $(document).on('shopify:section:unload', function (e) {
    $(e.target).find(SELECTOR).addBack(SELECTOR).each(function () {
      destroy(this);
    });
  });
})(jQuery);

// ============================================================
$('#lead-form').on('submit', function (e) {
  e.preventDefault();

  const endpoint = 'https://script.google.com/macros/s/AKfycbyQpJe5ZE_o8Nu1YOObrpuEtwtPEE5Sk-igd4V74SAstxxblbvbuRuazfdaY_o6fg/exec';
  const payload = {
    name: $(this).find('[name="name"]').val(),
    email: $(this).find('[name="email"]').val(),
    phone: $(this).find('[name="phone"]').val()
  };

  const body = new URLSearchParams(payload);

  fetch(endpoint, { method: 'POST', mode: 'no-cors', body: body })
    .then(function () {
      alert('Submitted');
      $('#lead-form')[0].reset();
    })
    .catch(function () {
      alert('Something went wrong');
    });
});

// CART RECOMMENDATIONS LOADER
$(function () {
  const SCOPE = 'cart-drawer-recommendations';

  const toggleLoader = (el, state) => {
    $(el).closest('product-item').find('.line-item__loader').prop('hidden', !state);
  };

  // Add to cart (single-variant product-form)
  $(document).on('submit', `${SCOPE} form[is="product-form"]`, function () {
    if (this.checkValidity()) toggleLoader(this, true);
  });

  // Quick view (multi-variant). The load events are non-bubbling, so they need a native capture listener.
  ['start', 'end'].forEach((type) => {
    document.addEventListener(`openable-element:load:${type}`, (e) => {
      if (!e.target.closest(SCOPE)) return;
      toggleLoader(e.target, type === 'start');
    }, true);
  });
});